import { Component } from '@nicolas-riciotti/light2';
import { isMobilePortrait } from '../../helpers/isMobile';
import getPosition from '../../helpers/getPosition';
import Lenis from '../../helpers/Lenis'

export default class BlockLanguages extends Component {

    created() {
        this.angle = -Math.PI/2;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this); 
        this._scroll   = 0;
    }

    resize() {
        this._width  = this.clientWidth;
        this._height = this.clientHeight;
        this.$slides.forEach((el,i) => {
            el._width  = el.clientWidth;
            el._height = el.clientHeight; 
            el._rand   = Math.random();
        });
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    detached() {
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
        this._io?.disconnect();
    }

    attached() {
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this._noBlur = this.hasAttribute('no-blur');

        this.$slides =this.querySelectorAll('[data-slide]');
        this.$slides.forEach((el,i) => {
            el.style.position = 'absolute';
            el.style.top      = 0;
            el.style.left     = 0;
            el._rand = Math.random();
        });

        Lenis?.on?.('scroll', this.onScroll)
        this.resize();

        this._inView = false;
        this._io = new IntersectionObserver((entries) => {
            this._inView = entries[0]?.isIntersecting ?? false;
        }, { rootMargin: '200px 0px' });
        this._io.observe(this);
    }

    onScroll(e) {
        this._scroll = e.animatedScroll ;
    }

    update() {

        if ( !this._inView ) {
            return;
        }

        // if ( window.innerWidth < 600 ) {
        //     return;
        // }

        const pos = getPosition(this);
 
        this.angle = (pos.top + this._scroll) / window.innerHeight * 0.3 - Math.PI*0.6; 

        if (this.stopped) {
            this.angle = - Math.PI*0.6;
        }

        let angleStep = (Math.PI * 2) / this.$slides.length;
        let maxW = 0;
        let maxH = 0;
        this.$slides.forEach((el,i) => {
            maxW = Math.max(el._width, maxW);
            maxH = Math.max(el._height, maxH);
        });
        const containerPos = getPosition(this);
        this.$slides.forEach((el,i) => {

            let x,y;
            if (window.innerWidth < 600) {
                x = this._width/2 - el._width/2 + Math.cos(i * angleStep + this.angle) * (this._width/2 +  el._width/2 ) ;
                y = this._height/2 - el._height/2 + Math.sin(i * angleStep + this.angle) * (this._height/2- maxH/2) ;
            }
            else {
                x = this._width/2  - el._width/2 + Math.cos(i * angleStep + this.angle) * (this._width/2 - maxW/2) ;
                y = this._height/2 - el._height/2 + Math.sin(i * angleStep + this.angle) * (this._height/2- maxH/2) ;
            }

            el.style.transform = `translate(${x}px, ${y}px) translateZ(0)`;

            if (!this._noBlur) {
                el.style.filter = `blur(${ ((Math.cos(el._rand * 5 + this.angle * 30)+1)/2) * 10 }px)`;
            }
            
        });
    }
}

customElements.define('block-languages', BlockLanguages);
